var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("incomming-call", {
    attrs: { show: _vm.show, id: _vm.id, type: _vm.type },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }